import { render, staticRenderFns } from "./WPPageManagerAddPage.vue?vue&type=template&id=24d88226&"
import script from "./WPPageManagerAddPage.vue?vue&type=script&lang=ts&"
export * from "./WPPageManagerAddPage.vue?vue&type=script&lang=ts&"
import style0 from "./WPPageManagerAddPage.vue?vue&type=style&index=0&id=24d88226&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports